import React, { useEffect, useState } from "react";
import { RetellWebClient } from "retell-client-js-sdk";
import "../App.css";
import "./css/Main.css";
import "./css/Widget.css"; // Import the minimal CSS file

const agentId = "agent_654c232310a10db5f7f5a78fa0";

interface RegisterCallResponse {
  access_token: string;
}

const retellWebClient = new RetellWebClient();

const ButtonComponent = () => {
  const [isCalling, setIsCalling] = useState(false);

  useEffect(() => {
    retellWebClient.on("call_started", () => {
      console.log("call started");
    });

    retellWebClient.on("call_ended", () => {
      console.log("call ended");
      setIsCalling(false);
    });

    retellWebClient.on("agent_start_talking", () => {
      console.log("agent_start_talking");
    });

    retellWebClient.on("agent_stop_talking", () => {
      console.log("agent_stop_talking");
    });

    retellWebClient.on("error", (error) => {
      console.error("An error occurred:", error);
      retellWebClient.stopCall();
    });
  }, []);

  const toggleConversation = async () => {
    if (isCalling) {
      retellWebClient.stopCall();
      setIsCalling(false);
    } else {
      try {
        const registerCallResponse = await registerCall(agentId);
        if (registerCallResponse.access_token) {
          await retellWebClient.startCall({
            accessToken: registerCallResponse.access_token,
          });
          setIsCalling(true);
        }
      } catch (error) {
        console.error("Error starting call:", error);
      }
    }
  };

  async function registerCall(agentId: string): Promise<RegisterCallResponse> {
    try {
      const response = await fetch("https://demo.braincx.ai:8080/create-web-call", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ agent_id: agentId }),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      return await response.json();
    } catch (err) {
      console.error("Error registering call:", err);
      throw err;
    }
  }

  return (
    <div className="button-container">
      <img
        src="/images/button.png"
        alt="Audio Button"
        onClick={toggleConversation}
        className="audio-button"
      />
      <p className="button-text">{isCalling ? "Call in progress..." : "Click to start call"}</p>
    </div>
  );
};

export default ButtonComponent;